import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Settings as SettingsIcon, History, User } from 'lucide-react';
import ConnectionHistory from '../components/ConnectionHistory';
import ProfileManagement from '../components/ProfileManagement';
import AppearanceSelector from '../components/AppearanceSelector';

const Settings: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab') as 'general' | 'history' | 'profile' | null;
  const [activeTab, setActiveTab] = useState<'general' | 'history' | 'profile'>(tabFromUrl || 'profile');

  React.useEffect(() => {
    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  const tabs = [
    { id: 'profile', name: 'Profil', icon: User },
    { id: 'history', name: 'Historique', icon: History },
    { id: 'general', name: 'Général', icon: SettingsIcon },
  ];

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-white">Paramètres</h1>
        <p className="text-dark-400 text-sm mt-1">
          Configurez votre application et gérez vos données
        </p>
      </div>

      <div className="border-b border-dark-700">
        <nav className="flex space-x-6">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id as typeof activeTab)}
                className={`
                  flex items-center space-x-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors
                  ${
                    activeTab === tab.id
                      ? 'border-primary-500 text-primary-500'
                      : 'border-transparent text-dark-400 hover:text-white hover:border-dark-300'
                  }
                `}
              >
                <Icon className="w-4 h-4" />
                <span>{tab.name}</span>
              </button>
            );
          })}
        </nav>
      </div>

      <div className="mt-4">
        {activeTab === 'general' && (
          <div className="space-y-4">
            <div>
              <h2 className="text-lg font-semibold text-white mb-1">Paramètres généraux</h2>
              <p className="text-dark-400 text-sm">
                Apparence et préférences de l&apos;application
              </p>
            </div>
            <AppearanceSelector />
          </div>
        )}

        {activeTab === 'profile' && <ProfileManagement />}

        {activeTab === 'history' && <ConnectionHistory />}
      </div>
    </div>
  );
};

export default Settings;
